import { render, staticRenderFns } from "./admin-product-single-main.vue?vue&type=template&id=efdd6fa8&"
import script from "./admin-product-single-main.vue?vue&type=script&lang=js&"
export * from "./admin-product-single-main.vue?vue&type=script&lang=js&"
import style0 from "./admin-product-single-main.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports